// extracted by mini-css-extract-plugin
module.exports = {"offer":"OrderStage_offer__1O0LD","deal":"OrderStage_deal__2w6Xd"};